import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend,
} from 'recharts';
import { formatCurrency } from '../../utils/formatters';

const COLORS = ['#2D1B69', '#7C5CBF', '#FFD700', '#4CAF50', '#F44336', '#2196F3'];

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const row = payload[0];
    return (
      <Box sx={{ bgcolor: 'background.paper', p: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1, boxShadow: 2 }}>
        <Typography variant="body2" fontWeight={600}>{row.name}</Typography>
        <Typography variant="body2">{formatCurrency(row.value)}</Typography>
      </Box>
    );
  }
  return null;
};

const ServiceBreakdown = ({ data = [] }) => {
  if (!data.length) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
        <Typography color="text.secondary">No service data available</Typography>
      </Box>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie data={data} dataKey="total" nameKey="_id" cx="50%" cy="50%" outerRadius={80} label={({ _id, total }) => `${_id}: ${formatCurrency(total)}`}>
          {data.map((_, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip content={<CustomTooltip />} />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default ServiceBreakdown;
